(function () {
  'use strict';

  /* ==================== الإعدادات ==================== */
  var CONFIG = {
    tapMode: 'cycle',         // 'cycle' | 'cycle-then-open'
    showDots: true,
    previewOnHover: true,     // ديسكتوب: مرور الماوس على اللون يعرض صورته
    swatchNavigates: false,   // false = الضغط على اللون ميفتحش صفحة المنتج
    imageWidth: 900,

    openOnDoubleClick: true,  // دبل كليك / دبل تاب = يفتح صفحة المنتج
    doubleTapDelay: 300,
    deferTapCycle: false,
    tapZoneOpen: false,       // true = يمين الصورة يبدّل، والباقي يفتح المنتج
    tapZoneWidth: 0.35,

    activeRing: false         // false = بوردر الثيم فقط (مفيش دايرة زيادة)
  };

  /* السواتش المؤكدة (من غير قاعدة الـ variant=) */
  var SWATCH_STRICT = [
    '[data-variant-image]', '[data-variant-id]', '[data-swatch]', '[data-option-value]',
    '.color-swatch', '.card-swatch', '.swatch__item', '.f-swatch__item', '.swatch-item',
    '.product-card__swatch a', '.card-product__swatch a', '.card__colors a',
    '.swatches a', '.swatch a', '.f-swatches a'
  ].join(',');

  /* السواتش المؤكدة + أي لينك فيه variant= (بيتفلتر بعدين بـ data-fx-link) */
  var SWATCH_SELECTOR = SWATCH_STRICT + ', a[href*="variant="]';

  /* ★ v1.4: عناصر لازم نتجاهلها تمامًا (+N / Quick view / مودالات) */
  var SKIP_SELECTOR = [
    '[data-quick-view]', '[data-quickview]', '[data-quick-add]', '[data-quick-shop]',
    '[data-modal]', '[data-modal-open]', '[data-fancybox]',
    '.quick-view', '.quickview', '.js-quick-view', '.quick-add', '.quick-shop',
    '.card-product__quick', '.f-quick-view',
    '.swatch-more', '.swatch__more', '.swatches__more', '.f-swatch__more',
    '.card__colors-more', '.color-swatch--more', '.swatch--more', '.more-colors'
  ].join(',');

  /* ==================== أدوات مساعدة ==================== */
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ★ perf: النتيجة بتتخزن بدل matchMedia في كل مرة */
  var _touch = null;
  function isTouchNow() {
    if (_touch === null) {
      _touch = window.matchMedia('(hover: none), (pointer: coarse)').matches || window.innerWidth < 768;
    }
    return _touch;
  }
  window.addEventListener('resize', function () { _touch = null; }, { passive: true });

  /* ★ v1.4: هل العنصر ده زرار "+3" أو Quick view؟ */
  function isSkipTarget(el) {
    if (!el || el.nodeType !== 1 || !el.closest) return false;
    if (el.hasAttribute('data-fx-skip')) return true;
    if (el.closest('[data-fx-skip]')) return true;
    if (el.closest(SKIP_SELECTOR)) return true;

    // زرار "+3" / "+2" ... (نص قصير = علامة + ورقم)
    var txt = (el.textContent || '').replace(/\s+/g, '');
    if (/^\+\d{1,2}$/.test(txt)) return true;

    // لو الضغط جوه عنصر ابن (span/svg)، نتحقق من الأب المباشر كمان
    var p = el.parentElement;
    if (p) {
      var ptxt = (p.textContent || '').replace(/\s+/g, '');
      if (/^\+\d{1,2}$/.test(ptxt)) return true;
    }
    return false;
  }

  /* بترجع السواتش الحقيقي فقط */
  function closestSwatch(el) {
    if (!el || !el.closest) return null;
    if (isSkipTarget(el)) return null;                              // ★ v1.4
    var sw = el.closest(SWATCH_SELECTOR);
    if (!sw) return null;
    if (isSkipTarget(sw)) return null;                              // ★ v1.4
    if (sw.hasAttribute && sw.hasAttribute('data-fx-link')) return null; // لينك أساسي للكارت
    return sw;
  }

  function swatchesIn(card) {
    return $all(SWATCH_SELECTOR, card).filter(function (el) {
      return !el.hasAttribute('data-fx-link') && !isSkipTarget(el); // ★ v1.4
    });
  }

  /* هل اللينك ده شيب لون؟ (بدون نص + صغير) */
  function isSwatchLike(a) {
    if (isSkipTarget(a)) return false;                              // ★ v1.4
    if (a.matches(SWATCH_STRICT) || a.closest(SWATCH_STRICT)) return true;
    var txt = (a.textContent || '').replace(/\s+/g, '');
    if (txt.length > 3) return false;                       // فيه نص → عنوان/سعر/زرار
    var im = a.querySelector('img');
    if (im && (parseInt(im.getAttribute('width') || '0', 10) >= 80)) return false;
    var r = a.getBoundingClientRect();
    if (r.width > 70) return false;                         // كبير → مش شيب
    return true;
  }

  var _lastTap = { el: null, t: 0 };
  function isDoubleTap(el) {
    if (!CONFIG.openOnDoubleClick) return false;
    var now = Date.now();
    var same = (_lastTap.el === el) && (now - _lastTap.t) <= CONFIG.doubleTapDelay;
    _lastTap.el = same ? null : el;
    _lastTap.t  = same ? 0 : now;
    return same;
  }

  function openProduct(url) {
    if (!url) return;
    window.location.href = url;
  }

  function absUrl(u) { return !u ? '' : (u.indexOf('//') === 0 ? 'https:' + u : u); }

  function sized(u, w) {
    u = absUrl(u);
    if (!u) return '';
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || CONFIG.imageWidth);
  }

  function fileKey(u) {
    var f = (u || '').split('?')[0].split('/').pop().toLowerCase();
    return f.replace(/_(\d+)x(\d+)?(_crop_[a-z]+)?(?=\.)/, '');
  }

  function productBase(href) {
    if (!href) return '';
    var m = href.split('#')[0].match(/^(.*\/products\/[^\/?#]+)/);
    return m ? m[1] : '';
  }

  var productCache = {};
  function fetchProduct(base) {
    if (!base) return Promise.resolve(null);
    if (!productCache[base]) {
      productCache[base] = fetch(base + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[base];
  }

  /* ============ التعامل الآمن مع الصور ============ */
  function remember(img) {
    if (typeof img.dataset.fxOrigSrc === 'undefined') {
      img.dataset.fxOrigSrc = img.getAttribute('src') || '';
      img.dataset.fxOrigSrcset = img.getAttribute('srcset') || '';
    }
    var pic = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
    if (pic) $all('source', pic).forEach(function (s) {
      if (typeof s.dataset.fxOrigSrcset === 'undefined') s.dataset.fxOrigSrcset = s.getAttribute('srcset') || '';
    });
  }

  function applyImage(img, url) {
    if (!img || !url || url === 'null' || url === 'undefined') return false; // منع src فاضي
    remember(img);
    var pic = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
    if (pic) $all('source', pic).forEach(function (s) { s.setAttribute('srcset', url); });
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.setAttribute('data-src', url);
    img.setAttribute('loading', 'eager');
    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('loaded');
    img.dataset.fxRepaired = '';
    img.src = url;
    return true;
  }

  function firstFromSrcset(ss) {
    return !ss ? '' : ss.split(',')[0].trim().split(' ')[0];
  }

  /* ====== إصلاح الصور المكسورة (Back / bfcache) ====== */
  function repairImages(root) {
    $all('img', root || document).forEach(function (img) {
      var src = img.getAttribute('src');
      var broken = !src || src === 'null' || src === 'undefined' || (img.complete && img.naturalWidth === 0);
      if (!broken || img.dataset.fxRepaired === '1') return;
      img.dataset.fxRepaired = '1';
      var fb = img.dataset.fxOrigSrc || img.getAttribute('data-src') ||
               firstFromSrcset(img.getAttribute('data-srcset') || img.getAttribute('srcset'));
      if (fb) { img.removeAttribute('srcset'); img.src = absUrl(fb); }
    });
  }

  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.fxRepaired === '1') return;
    img.dataset.fxRepaired = '1';
    var fb = img.dataset.fxOrigSrc || img.getAttribute('data-src');
    if (fb && absUrl(fb) !== img.src) { img.removeAttribute('srcset'); img.src = absUrl(fb); }
  }, true);

  window.addEventListener('pageshow', function (e) {
    setTimeout(function () { repairImages(document); }, 0);
    if (e.persisted) {
      setTimeout(function () { repairImages(document); }, 250);
      setTimeout(function () { repairImages(document); }, 800);
    }
  });

  /* ==================== بناء الكروت ==================== */
  function getCard(link) {
    return link.closest('.f-column') ||
           link.closest('.card-product, .product-card, .f-card, [class*="card-product"], [class*="product-card"]') ||
           link.parentElement;
  }

  /* ★ perf: getBoundingClientRect بيسبب forced reflow — بنقيس بس لو فيه أكتر من مرشح */
  function pickMediaLink(card) {
    var links = $all('a[href*="/products/"]', card), cands = [], ims = [];
    for (var i = 0; i < links.length; i++) {
      var a = links[i], im = a.querySelector('img');
      if (!im) continue;
      if (isSkipTarget(a)) continue;                                // ★ v1.4
      var swWrap = a.closest('[class*="swatch"], [class*="color-option"], [class*="variant-option"]');
      if (swWrap && swWrap !== card) continue;
      cands.push(a); ims.push(im);
    }
    if (!cands.length) return null;
    if (cands.length === 1) return cands[0];
    var best = null, bestArea = -1;
    for (var k = 0; k < cands.length; k++) {
      var im2 = ims[k];
      var area = (parseInt(im2.getAttribute('width') || 0, 10) || 0) * (parseInt(im2.getAttribute('height') || 0, 10) || 0);
      if (!area) { var r = im2.getBoundingClientRect(); area = r.width * r.height; }
      if (area > bestArea) { bestArea = area; best = cands[k]; }
    }
    return best;
  }

  /* ★ perf: الكروت بتتجهز لما تقرّب من الشاشة مش كلها مرة واحدة */
  var _io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var c = entries[i].target;
      _io.unobserve(c);
      initCard(c);
    }
  }, { rootMargin: '400px 0px' }) : null;

  function initAll(root) {
    root = root || document;
    var links = $all('a[href*="/products/"]', root);
    if (root.nodeType === 1 && root.matches && root.matches('a[href*="/products/"]')) links.push(root);
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var card = getCard(link);
      if (!card || card.__fxInit || card.__fxQueued) continue;
      if (!link.querySelector('img')) continue;
      card.__fxQueued = true;
      if (_io) _io.observe(card); else initCard(card);
    }
  }

  /* ★ v1.4: تعليم عناصر +N و Quick view داخل الكارت */
  function markSkippables(card) {
    $all('a, button, [role="button"], span, div', card).forEach(function (n) {
      if (n.hasAttribute('data-fx-skip')) return;
      var t = (n.textContent || '').replace(/\s+/g, '');
      if (/^\+\d{1,2}$/.test(t) || n.matches(SKIP_SELECTOR)) {
        n.setAttribute('data-fx-skip', '1');
      }
    });
  }

  function initCard(card) {
    if (!card || card.__fxInit) return;

    /* ★ perf: markSkippables اتشالت — isSkipTarget() بتعمل نفس الفحص وقت الضغط بس */

    var mediaLink = pickMediaLink(card);
    if (!mediaLink) return;

    var imgs = $all('img', mediaLink).filter(function (im) {
      if (closestSwatch(im)) return false;
      var w = parseInt(im.getAttribute('width') || '0', 10);
      return !(w && w < 80);
    });
    if (!imgs.length) return;

    card.__fxInit = true;
    card.setAttribute('data-fx-card', '1');   // ★ perf: بوابة رخيصة للـ hover

    /* نعلّم اللينكات الأساسية (صورة/عنوان/سعر/زرار) قبل أي تعديل على الـ href */
    $all('a[href*="/products/"]', card).forEach(function (a) {
      if (a.hasAttribute('data-fx-skip')) return;                   // ★ v1.4
      if (a === mediaLink || !isSwatchLike(a)) a.setAttribute('data-fx-link', '1');
    });

    swatchesIn(card).forEach(function (s) { s.classList.add('fx-tap'); });

    var state = {
      card: card, link: mediaLink, imgs: imgs,
      base: productBase(mediaLink.getAttribute('href')),
      images: [], index: 0, dots: null, fetched: false, tapTimer: null,
      hasInnerSlider: !!mediaLink.querySelector('.swiper, .flickity-enabled')
    };
    card.__fxState = state;

    imgs.forEach(remember);
    state.images = imgs.map(function (im) { return im.currentSrc || im.getAttribute('src') || ''; }).filter(Boolean);

    bindMedia(state);
  }

  /* ====== الضغط على الصورة + الدبل تاب ====== */
  function bindMedia(state) {
    var el = state.link, sx = 0, sy = 0, moved = false;
    el.classList.add('fx-tap');
    el.style.webkitTapHighlightColor = 'transparent';

    el.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; moved = false; prefetch(state);
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) moved = true;
    }, { passive: true });

    el.addEventListener('mouseenter', function () { prefetch(state); });

    el.addEventListener('click', function (e) {
      if (!isTouchNow() || state.hasInnerSlider) return;
      if (moved) return;
      if (isSkipTarget(e.target)) return;                           // ★ v1.4
      if (closestSwatch(e.target)) return;

      if (isDoubleTap(el)) {                       // دبل تاب = يفتح المنتج
        clearTimeout(state.tapTimer);
        e.preventDefault();
        e.stopPropagation();
        openProduct(el.getAttribute('href'));
        return;
      }

      if (state.images.length < 2) return;

      if (CONFIG.tapZoneOpen) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX || 0) - r.left;
        if (x < r.width * (1 - CONFIG.tapZoneWidth)) return;
      }

      var last = state.index >= state.images.length - 1;
      if (CONFIG.tapMode === 'cycle-then-open' && last) return;

      e.preventDefault();
      e.stopPropagation();

      if (CONFIG.deferTapCycle) {
        clearTimeout(state.tapTimer);
        state.tapTimer = setTimeout(function () { show(state, state.index + 1); }, CONFIG.doubleTapDelay);
      } else {
        show(state, state.index + 1);
      }
    });

    el.addEventListener('dblclick', function () {
      if (isTouchNow()) return;
      openProduct(el.getAttribute('href'));
    });
  }

  function prefetch(state) {
    if (state.fetched) return;
    state.fetched = true;
    fetchProduct(state.base).then(function (p) {
      if (!p || !p.images || !p.images.length) return;
      state.product = p;
      state.images = p.images.map(function (u) { return sized(u); });
      var cur = fileKey(state.imgs[0].currentSrc || state.imgs[0].src);
      state.images.some(function (u, i) {
        if (fileKey(u) === cur) { state.index = i; return true; }
        return false;
      });
      buildDots(state);
    });
  }

  function show(state, i) {
    if (!state.images.length) return;
    state.index = (i + state.images.length) % state.images.length;
    applyImage(state.imgs[0], state.images[state.index]);
    if (state.imgs[1] && state.images.length > 1) {
      applyImage(state.imgs[1], state.images[(state.index + 1) % state.images.length]);
    }
    updateDots(state);
  }

  function showUrl(state, url) {
    if (!url) return;
    var idx = -1, key = fileKey(url);
    state.images.some(function (u, i) { if (fileKey(u) === key) { idx = i; return true; } return false; });
    if (idx > -1) { show(state, idx); return; }
    applyImage(state.imgs[0], url);
    updateDots(state);
  }

  /* ====== الألوان ====== */
  function variantId(sw) {
    var id = sw.getAttribute('data-variant-id');
    if (id && /^\d+$/.test(id)) return parseInt(id, 10);
    var a = sw.matches('a') ? sw : sw.closest('a');
    var href = a && a.getAttribute('href');
    var m = href && href.match(/[?&]variant=(\d+)/);
    if (m) return parseInt(m[1], 10);
    if (sw.tagName === 'INPUT' && /^\d{8,}$/.test(sw.value || '')) return parseInt(sw.value, 10);
    var inp = sw.querySelector && sw.querySelector('input[value]');
    if (inp && /^\d{8,}$/.test(inp.value || '')) return parseInt(inp.value, 10);
    return null;
  }

  function swatchLabel(sw) {
    return (sw.getAttribute('data-value') || sw.getAttribute('data-option-value') ||
            sw.getAttribute('data-swatch') || sw.getAttribute('data-color') ||
            sw.getAttribute('title') || sw.getAttribute('aria-label') ||
            (sw.textContent || '')).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function directImage(sw) {
    return sw.getAttribute('data-variant-image') || sw.getAttribute('data-image') ||
           sw.getAttribute('data-media-src') || sw.getAttribute('data-featured-image') || '';
  }

  /* بيعدّل لينكات الكارت الأساسية بس */
  function syncHref(state, vid) {
    if (!vid) return;
    $all('a[data-fx-link][href*="/products/"]', state.card).forEach(function (a) {
      if (a.hasAttribute('data-fx-skip')) return;                   // ★ v1.4
      var h = (a.getAttribute('href') || '').split('#')[0];
      if (!h) return;
      h = h.replace(/([?&])variant=\d+/, '$1variant=' + vid);
      if (h.indexOf('variant=') === -1) h += (h.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
      a.setAttribute('href', h);
    });
  }

  /* بوردر الثيم بس — الرينج بتاعنا اختياري ومتوقّف */
  function markActive(state, sw) {
    swatchesIn(state.card).forEach(function (el) {
      el.classList.remove('is-active', 'fx-swatch-active');
    });
    sw.classList.add('is-active');                                 // ستايل الثيم الأصلي
    if (CONFIG.activeRing) sw.classList.add('fx-swatch-active');    // متوقّف افتراضيًا
    var inp = sw.matches('input') ? sw : (sw.querySelector && sw.querySelector('input[type="radio"]'));
    if (inp) inp.checked = true;
  }

  function selectSwatch(state, sw, persist) {
    var d = directImage(sw);
    if (d) {
      showUrl(state, sized(d));
      if (persist) { markActive(state, sw); syncHref(state, variantId(sw)); }
      return;
    }

    var vid = variantId(sw), label = swatchLabel(sw);
    fetchProduct(state.base).then(function (p) {
      if (!p) return;
      state.product = p;
      if (p.images && p.images.length) state.images = p.images.map(function (u) { return sized(u); });

      var url = '', matched = null, i, j;

      if (vid) {
        for (i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === vid) { matched = p.variants[i]; break; }
        }
      }
      if (!matched && label) {
        for (i = 0; i < p.variants.length; i++) {
          var opts = p.variants[i].options || [];
          for (j = 0; j < opts.length; j++) {
            if (String(opts[j]).toLowerCase().trim() === label) { matched = p.variants[i]; break; }
          }
          if (matched) break;
        }
      }
      if (matched && matched.featured_image && matched.featured_image.src) {
        url = sized(matched.featured_image.src);
      }
      if (!url && label && p.media) {
        for (i = 0; i < p.media.length; i++) {
          var md = p.media[i];
          if (md.alt && md.alt.toLowerCase().indexOf(label) > -1 && md.preview_image) {
            url = sized(md.preview_image.src); break;
          }
        }
      }

      if (!url) return;
      showUrl(state, url);
      if (persist) { markActive(state, sw); syncHref(state, (matched && matched.id) || vid); }
    });
  }

  /* Capture عشان يسبق هاندلر الثيم */
  document.addEventListener('click', function (e) {
    if (isSkipTarget(e.target)) return;        // ★ v1.4 — سيب +3 / quick view يشتغلوا طبيعي
    if (CONFIG.swatchNavigates) return;
    var sw = closestSwatch(e.target);
    if (!sw) return;

    var link = sw.closest('a[href*="/products/"]') || sw;
    var card = getCard(link);
    if (!card) return;
    if (!card.__fxState) initCard(card);
    var state = card.__fxState;
    if (!state) return;
    if (sw === state.link) return;

    e.preventDefault();
    e.stopPropagation();

    if (isDoubleTap(sw)) {                       // دبل كليك على اللون = يفتح المنتج باللون ده
      var a = sw.matches('a[href*="/products/"]') ? sw : sw.closest('a[href*="/products/"]');
      var href = (a && a.getAttribute('href')) || (state.link && state.link.getAttribute('href')) || '';
      var vid = variantId(sw);
      if (href && vid) {
        href = href.split('#')[0].replace(/([?&])variant=\d+/, '$1variant=' + vid);
        if (href.indexOf('variant=') === -1) href += (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
      }
      openProduct(href);
      return;
    }

    selectSwatch(state, sw, true);
  }, true);

  /* ديسكتوب: preview بالماوس */
  document.addEventListener('mouseover', function (e) {
    if (!CONFIG.previewOnHover || isTouchNow()) return;
    var t = e.target;
    /* ★ perf: فحص واحد رخيص قبل أي شغل تقيل */
    if (!t || t.nodeType !== 1 || !t.closest || !t.closest('[data-fx-card]')) return;
    if (isSkipTarget(t)) return;                                    // ★ v1.4
    var sw = closestSwatch(t);
    if (!sw) return;
    var card = getCard(sw);
    if (!card || !card.__fxState) return;
    var state = card.__fxState;
    if (sw === state.link || state.__lastPreview === sw) return;
    state.__lastPreview = sw;
    selectSwatch(state, sw, false);
  });

  /* ==================== النقط (Dots) ==================== */
  function buildDots(state) {
    if (!CONFIG.showDots || !isTouchNow()) return;
    if (state.dots && state.dots.parentNode) state.dots.parentNode.removeChild(state.dots);
    state.dots = null;

    var n = Math.min(state.images.length, 8);
    if (n < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'fx-dots';
    for (var i = 0; i < n; i++) wrap.appendChild(document.createElement('span'));
    if (getComputedStyle(state.link).position === 'static') state.link.style.position = 'relative';
    state.link.appendChild(wrap);
    state.dots = wrap;
    updateDots(state);
  }

  function updateDots(state) {
    if (!state.dots) return;
    var kids = state.dots.children;
    for (var i = 0; i < kids.length; i++) {
      kids[i].className = (i === state.index % kids.length) ? 'is-active' : '';
    }
  }

  /* ==================== CSS مدمج ==================== */
  var css = document.createElement('style');
  css.textContent =
    '.fx-tap{touch-action:manipulation;-webkit-tap-highlight-color:transparent}' +
    '.fx-dots{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:5px;pointer-events:none;z-index:3}' +
    '.fx-dots span{width:6px;height:6px;border-radius:50%;background:rgba(0,0,0,.22);transition:.2s}' +
    '.fx-dots span.is-active{background:rgba(0,0,0,.85);transform:scale(1.2)}' +
    '[data-fx-skip]{pointer-events:auto}' +
    '@media (hover:hover) and (pointer:fine){.fx-dots{display:none}}';
  document.head.appendChild(css);

  /* ==================== التشغيل ==================== */
  var _idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };
  var _booted = false;

  function boot() {
    initAll(document);
    if (!_booted) { _booted = true; repairImages(document); }
  }

  /* ★ perf: بنفحص العناصر الجديدة بس، مش الصفحة كلها */
  function startObserver() {
    var pending = [], scheduled = false;

    function flush() {
      scheduled = false;
      var nodes = pending; pending = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].isConnected) initAll(nodes[i]);
      }
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList.contains('fx-dots') || n.closest('.fx-dots')) continue;
          pending.push(n);
        }
      }
      if (!pending.length || scheduled) return;
      scheduled = true;
      _idle(flush, { timeout: 500 });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ★ perf: المراقبة بتبدأ بعد ما الصفحة تتبني، مش أثناء بنائها */
  function start() { boot(); startObserver(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();